export function addDataToGetItinerary(dataToGetItinerary) {
  return {
    type: 'ADD_DATA_TO_GET_ITINERARY',
    dataToGetItinerary
  }
}